export default "/_next/static/images/light-gray-loader3-298ed6c543516c6d359b02faa1cc3b88.gif";